import zsearchSlice from "../slices/zsearchSlice";

export const {
  RequestIndexes,
  SuccessIndexes,
  FailureIndexes,
  RequestMailGatewayLogs,
  SuccessMailGatewayLogs,
  FailureMailGatewayLogs,
  RequestPefDevices,
  SuccessPefDevices,
  FailurePefDevices,
  RequestPefLogs,
  SuccessPefLogs,
  FailurePefLogs,
  RequestDashboardData,
  SuccessDashboardData,
  FailureDashboardData,
  RequestDashboardHealth,
  SuccessDashboardHealth,
  FailureDashboardHealth,
} = zsearchSlice.actions;
